/**
 * 锋利黄金三角碰撞徽标：与 favicon 同源剪影，供 BrandMark 锁紧组合使用。
 *
 * Callers: `BrandMark`（顶栏 / 认证 / 设置 / onboarding）
 *
 * Modules:
 * - GlitchSlashMark — accent/danger 叠层 + currentColor 主体
 */

type GlitchSlashMarkProps = {
  className?: string;
};

/** 主三角腰:底 = φ，副三角缩放 1/φ，共用顶点；色差位移 1.6:1 ≈ φ。 */
function Crest() {
  return (
    <>
      <polygon points="19.07,12.93 10.88,29 3,21.12" />
      <polygon points="19.07,12.93 24.13,3 29,7.87" />
    </>
  );
}

/** 24px 锁紧组合左侧徽标；主体跟前景色，暗色侧栏仍可读。 */
export function GlitchSlashMark({ className }: GlitchSlashMarkProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      focusable="false"
      viewBox="0 0 32 32"
    >
      <g fill="var(--accent)" transform="translate(-1.6 -1)">
        <Crest />
      </g>
      <g fill="var(--danger)" transform="translate(1.6 1)">
        <Crest />
      </g>
      <g fill="currentColor">
        <Crest />
      </g>
    </svg>
  );
}
